import { render, staticRenderFns } from "./NavigationTitle.vue?vue&type=template&id=ec949320&scoped=true"
import script from "./NavigationTitle.vue?vue&type=script&lang=js"
export * from "./NavigationTitle.vue?vue&type=script&lang=js"
import style0 from "./NavigationTitle.vue?vue&type=style&index=0&id=ec949320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec949320",
  null
  
)

export default component.exports